import {MDCSelect} from '@material/select';

$(document).on('turbolinks:load', function () {
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }
    let $stateMdcSelect = document.querySelector("[data-element-type='student_address[state_id]']")
    let stateMdcSelect
    let initialSelectedState
    if ($stateMdcSelect != null) {
        stateMdcSelect = new MDCSelect($stateMdcSelect);
        initialSelectedState = stateMdcSelect.value
    }


    let address_modal = $('#address-modal')
    let body = $(document.body)
    let reward_center_id = $("#reward-center").attr('data-reward-center')

    let orderModal = $('#order-modal')
    let originalAddressForm = $("#address_form")

    $('#fill-address').on('click', function () {
        body.css('overflow', 'hidden')
        address_modal.css('display', 'block')
    })

    $(window).on('click', function (event) {
        if (event.target === address_modal.get(0)) {
            body.css('overflow', 'auto')
            address_modal.css('display', 'none')
            originalAddressForm.trigger('reset')
            if ($stateMdcSelect != null) {
                stateMdcSelect.value = initialSelectedState
            }

        }
    })

    $('.close-address-modal').on('click', function () {
        address_modal.hide()
        body.css('overflow', 'auto')
        originalAddressForm.trigger('reset')
        if ($stateMdcSelect != null) {
            stateMdcSelect.value = initialSelectedState
        }
    })

    $('#address-modal-close').on('click', function () {
        address_modal.hide()
        body.css('overflow', 'auto')
        originalAddressForm.trigger('reset')
        if ($stateMdcSelect != null) {
            stateMdcSelect.value = initialSelectedState
        }
    })


    $('#open-order-modal').on('click', function () {
        body.css('overflow', 'hidden')
        orderModal.css('display', 'block')
    })

    $(window).on('click', function (event) {
        if (event.target === orderModal.get(0)) {
            body.css('overflow', 'auto')
            orderModal.css('display', 'none')
        }
    })

    $(document).on('click', '[data-element-type="product"]', function () {
        let product_id = $(this).attr('data-product-id');
        let product_modal = $(`#product-${product_id}`)
        product_modal.css('display', 'block')
        body.css('overflow', 'hidden')
        let productCost = parseInt(product_modal.find("#product-cost").text())
        if (($(`#product-${product_id} span[id^=has_address]`).is(":visible")) && can_exchange_product(productCost)) {
            let getItButton = product_modal.find("#place-order-btn")
            enable_button(getItButton)
        }
    })

    $('.v2-modal #fill-address').on('click', function () {
        address_modal.css('display', 'block')
    })


    $('.close-button').on('click', function () {
        let modal = $(this).parent().closest('div.v2-modal')
        modal.hide()
        body.css('overflow', 'auto')
    })

    $(window).on('click', function (event) {
        if (event.target.id.includes("product-")) {
            body.css('overflow', 'auto')
            $("div[id^=product-]").hide()
        }
    })

    $('#faq-accordion').on('click', '.question', function (e) {
        let text = $(this).next("p");
        if (text.is(":hidden")) {
            text.show();
        } else {
            text.hide();
        }
    });


    let inputs = $("#address_form :input:not(#student_address_street_2):not(button)");
    let save_button = $("#address-modal-save")

    function is_form_valid(inputs) {
        let invalid_fields = inputs.filter(function () {
            return $.trim($(this).val()).length === 0
        })
        return invalid_fields.length === 0
    }

    if (is_form_valid(inputs)) {
        save_button.prop('disabled', false)
        save_button.removeClass('btn-disabled')
        save_button.addClass('btn-orange')
        save_button.addClass('btn-orange')
    }

    inputs.on('keyup change input', function () {
        if (is_form_valid(inputs)) {
            save_button.prop('disabled', false)
            save_button.removeClass('btn-disabled')
            save_button.addClass('btn-orange')
        } else {
            save_button.prop('disabled', true)
            save_button.removeClass('btn-orange')
            save_button.addClass('btn-disabled')
        }
    })

    save_button.on('click', function () {
        if (is_form_valid(inputs)) {
            disable_button(save_button)
            save_button.text("Saving...")
            let endpoint = $("#address_form").attr("action")
            Rails.ajax({
                type: "POST",
                url: endpoint,
                data: Rails.serializeElement(Rails.$("#address_form")[0]),
                success: (response) => {
                    display_alert("Your address was successfully updated!", "success")
                    $(".without-address").each(function () {
                        let element = $(this)
                        element.hide()
                    })
                    if (!$("#has_address").length) {
                        $(".address-tip").append("<span class='tip-text-gray has-address' id='has_address'>This reward will ship to this address within 2 weeks of the rewards window closing.</span>")
                        if ($("div[id^=product-]").is(':visible')) {
                            let productModal = $("div[id^=product-]:visible")
                            let productCost = parseInt(productModal.find("#product-cost").text())
                            if (can_exchange_product(productCost)) {
                                let getItButton = productModal.find("#place-order-btn")
                                enable_button(getItButton)
                            }
                        }
                    }
                    address_modal.hide()
                    body.css('overflow', 'auto')
                },
            })
        }
    })

    $(document).on('click', '[data-element-type="getit_button"]', function (e) {
        let button = $(this)
        let productId = $(this).attr('data-product-id')
        let productModal = $(this).parents('.v2-modal')
        let errorMessage = productModal.find('.error')
        let form = productModal.find('form')
        let action = form.attr('action')

        errorMessage.remove()
        disable_button(button)
        button.text("Please wait")
        Rails.ajax({
            type: "POST",
            url: action,
            data: Rails.serializeElement(Rails.$(`#product-${productId}-form`)[0]),
            success: (response) => {
                enable_button(button)
                button.text("Get it")
                productModal.hide()
                body.css('overflow', 'auto')
                display_alert("Your order was successfully registered", "success")
                setTimeout(function () {
                    location.reload()
                }, 1000)
            },
            error: (response) => {
                enable_button(button)
                button.text("Get it")
                Object.keys(response).forEach((key, index) => {
                    if (key === 'not_enough_points') {
                        display_alert(response['not_enough_points'], "error")
                    } else {
                        response[key].forEach((message) => {
                            $(`[data-field-type=${key}-for-${productId}]`).append(`<small class="error" data-type-error="${key}">${message}</small>`)
                        })
                    }


                })
            }
        })

    })

    $(document).on('click', '[data-element-type="product"]', function () {
        let product_id = $(this).attr('data-product-id');
        let product_modal = $(`#product-${product_id}`)
        let options = product_modal.find('li')
        let size_input = product_modal.find('input[id^=size-for-]')
        let mdcSelect = product_modal.find('.mdc-select')
        let errorMessage = product_modal.find('.error')
        let quantityField = product_modal.find('input[type=number]')
        let productCostSpan = product_modal.find("#product-cost")
        let productInitialCost = parseInt(productCostSpan.text())
        let leftoverPointsSpan = product_modal.find("#leftover-points-text")
        let modalTitle = product_modal.find("#points-spend-h4")
        let quantityFieldInput = quantityField.parent()

        options.on('click', function () {
            let element = $(this)
            size_input.val(element.text()).trigger('change')
        })

        size_input.on('change', function () {
            if (size_input.attr('value') !== '') {
                mdcSelect.removeClass('mdc-select--invalid')
                errorMessage.hide()
            }
        })

        quantityField.on('input', function () {
            $(`[data-field-type=quantity-for-${product_id}]`).find(".error").hide()
            quantityFieldInput.removeClass("mdc-text-field--invalid")
            let typedQuantity = $(this).val() !== "" ? parseInt($(this).val()) : 0
            let productUpdatedCost = productInitialCost * typedQuantity
            if (typedQuantity > 10) {
                quantityFieldInput.addClass("mdc-text-field--invalid")
                modalTitle.text("Ops... maximum of 10 items allowed")
                leftoverPointsSpan.text("")
                $(`[data-field-type=quantity-for-${product_id}]`).append(`<small class="error" data-type-error="quantity">must be less than or equal 10</small>`)
            } else if (typedQuantity <= 0) {
                quantityFieldInput.addClass("mdc-text-field--invalid")
                modalTitle.text("Ops... minimum of 1 item allowed")
                leftoverPointsSpan.text("")
                $(`[data-field-type=quantity-for-${product_id}]`).append(`<small class="error" data-type-error="quantity">must be greater than or equal 1</small>`)
            } else {
                $(`[data-field-type=quantity-for-${product_id}]`).find(".error").hide()
                quantityFieldInput.removeClass("mdc-text-field--invalid")
                modalTitle.html(`Spend <span id='product-cost'>${productUpdatedCost}</span> ${pluralize_points(productUpdatedCost)}`)
                leftoverPointsSpan.text(return_exchange_points_text(productUpdatedCost))
            }
        })
    })

    $(document).on('click', '[data-element-type="remove-item"]', function () {
        let orderId = $(this).attr('data-order-id')
        let orderDialog = $(`#remove-${orderId}-dialog`)
        orderDialog.show()
    })

    $('.dialog-close').on('click', function () {
        let dialog = $(this).parent().closest('div.v2-dialog')
        dialog.hide()
    })

    $(document).on('click', '[data-element-type="remove-order"]', function (e) {
        let button = $(this)
        let orderId = $(this).attr('data-order-id')
        let orderItem = $(`#item-${orderId}`)
        let productId = $(this).attr('data-product-id')
        let productOrderSize = orderItem.find('[data-element-type="order-item-size"]').attr('data-order-size')
        disable_button(button)
        button.text("Please wait...")
        Rails.ajax({
            type: "DELETE",
            url: `/v2/reward_orders?product_id=${productId}&size=${productOrderSize}`,
        })
    })

})

function disable_button(button) {
    button.prop('disabled', true)
    button.addClass('btn-disabled')
    button.removeClass('btn-orange')
}

function enable_button(button) {
    button.prop('disabled', false)
    button.removeClass('btn-disabled')
    button.addClass('btn-orange')
}

function display_alert(message, type) {
    let alert = $(`#reward-center .alert-${type}`)

    alert.find('span').html(message)
    alert.css('display', 'flex')
    alert[0].classList.add('animate__animated', 'animate__bounceIn');

    setTimeout(function () {
        alert.css('display', 'none');
        alert[0].classList.remove('animate__animated', 'animate__bounceIn');
    }, 3000)
}

function update_address_component(address) {
    $(".address-container .address-info h6").each(function () {
        let element = $(this)
        element.text(`${address.name} — ${address.street_1} — ${address.city}, ${address.state.state_name} ${address.zip_code}`)
    })
}

function can_exchange_product(productCost) {
    let remainingPoints = parseInt($('#remaining-points').text())

    return remainingPoints >= productCost
}

function calculate_refund_points(productCost) {
    let currentRemainingPoints = parseInt($("#remaining-points").text())
    return currentRemainingPoints + productCost
}

function update_available_points(updatedPoints) {
    let remainingPointsElement = $("#remaining-points")
    remainingPointsElement.text(updatedPoints)
}

function update_percentage_bar(productCost) {
    let totalPoints = parseInt($('#total-points').text())
    let percentBar = $(".percent-bar")
    let productPercentageWidth = (productCost / totalPoints) * 100
    let currentWidth = percentBar.width() / percentBar.parent().width() * 100
    percentBar.width(`${currentWidth + productPercentageWidth}%`)
}

function pluralize_points(numberOfPoints) {
    if (numberOfPoints === 1) {
        return "point"
    }
    return "points"
}

function return_exchange_points_text(productCost) {
    let availableInitialPoints = parseInt($('#remaining-points').text())
    let availablePoints = parseInt($('#remaining-points').text()) - productCost
    productCost = parseInt(productCost)

    if (availablePoints === productCost) {
        return "You will not have remaining points"
    } else if (availableInitialPoints < productCost) {
        let difference = productCost - availableInitialPoints
        return `You will need ${difference} more ${pluralize_points(difference)} for this item`
    } else {
        return `You will have ${availablePoints} ${pluralize_points(productCost)} left over.`
    }
}
